import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { dataService } from '../../Services/data.service';
import { useTranslation } from 'react-i18next';
import { Check, ArrowRight, ScanBarcode } from 'lucide-react';
import { bookingTypes } from '../../Config/constants';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import Keyboard from 'react-simple-keyboard';
import 'react-simple-keyboard/build/css/index.css';

export default function WriteOffMaterial(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    const [currentStep, setCurrentStep] = useState(1);
    const [category, setCategory] = useState(1);

    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const [barcode, setBarcode] = useState(null);
    const [enterManually, setEnterManually] = useState(false);
    const [normalKeyboardLayoutName, setNormalKeyboardLayoutName] = useState("default");

    const nextStep = (nextCategory) => {
        setCurrentStep(currentStep + 1);
        if (nextCategory) {
            setCategory(category + 1);
        }
    }

    const handleBarcodeChange = (input) => {
        setBarcode(input);
    }

    const handleKeyPress = (button) => {
        if (button === "{shift}") {
            setNormalKeyboardLayoutName(normalKeyboardLayoutName === "default" ? "shift" : "default");
        }
    };

    const handleBarcodeInputKeyDown = (event) => {
        if (event.key === "Enter") {
            if (barcode !== "" && barcode !== null) {
                postRecyclingHistoryEntry();
            }
        }
    }

    const postRecyclingHistoryEntry = () => {
        setLoading(true);
        // Post recycling history entry
        dataService.postRecyclingHistoryEntry({
            bookingTypeId: bookingTypes.WRITE_OFF,
            carrierBarcode: barcode.trim(),
            machineId: props.workstation.selectedRecyclingWorkstationId,
            insertedByUserId: parseInt(props.user.userInfo.sub)
        }).then((response) => {
            console.log("write off material response: ", response);
            nextStep(true);
            setLoading(false);
        }).catch((error) => {
            console.log(error);

            let errorText = error.toString().split(":")[0];
            setErrorMessage(t(errorText));
            setLoading(false);
        });
    }

    const reset = () => {
        setCurrentStep(1);
        setCategory(1);
        setErrorMessage("");
        setBarcode("");
    }

    // Stepper - Step component
    const Step = ({ stepNumber, stepTitle }) => {
        return (
            <div className={classes.step}>
                <div className={classes.step__number} style={{ backgroundColor: category > stepNumber ? "#5CC958" : category < stepNumber ? "#DCDCDC" : "#4654FB" }}>
                    {category > stepNumber ? <Check size={20} /> : stepNumber}
                </div>
                <p className={classes.step__title} style={{ color: category > stepNumber ? "#5CC958" : category < stepNumber ? "#DCDCDC" : "#4654FB" }}>
                    {t(stepTitle)}
                </p>
                <div className={classes.step__progressBarContainer}>
                    <div className={classes.step__progressBarBackground} />
                    <div className={classes.step__progressBar} style={{ width: `${category > stepNumber ? "100%" : "0%"}` }} />
                </div>
            </div>
        )
    }

    return (
        <div className={classes.registerContainer}>
            <div className={classes.stepper}>
                <Step stepNumber={1} stepTitle="Drager scannen" />
                <Step stepNumber={2} stepTitle="Verwerken" />
            </div>
            <div className={classes.currentStepContainer}>
                <div className={classes.currentStepCard}>
                    {currentStep === 1 && <>
                        <h1 className={classes.currentStep__title}>{t("Scan barcode")}</h1>
                        {!errorMessage ?
                            <>

                                {loading ?
                                    <div className={classes.interactionContainer}>
                                        <div className={classes.loaderContainer}>
                                            <span className={classes.loader} />
                                        </div>
                                    </div>
                                    :
                                    <>
                                        <p className={classes.currentStep__subtitle}>{t("Scan the barcode found on the carrier")}</p>
                                        <div className={classes.interactionContainerCentered}>
                                            <div className={classes.input__container}>
                                                <input autoFocus className={classes.input__field} type="text" onChange={(e) => setBarcode(e.target.value)} onKeyDown={(e) => handleBarcodeInputKeyDown(e)} value={barcode}></input>
                                                <ScanBarcode className={classes.input__icon} size={24} />
                                            </div>
                                            {!enterManually ?
                                                <button className={classes.currentStep__secondaryButton} onClick={() => setEnterManually(true)}>{t("Enter manually")}</button>
                                                :
                                                <Keyboard layoutName={normalKeyboardLayoutName} onChange={handleBarcodeChange} onKeyPress={handleKeyPress} />
                                            }
                                        </div>
                                        <button className={`${classes.currentStep__nextStepButton} ${!barcode || barcode.trim() == "" ? 'disabled' : ''}`} onClick={() => postRecyclingHistoryEntry()}>
                                            {t("Process")}
                                            <ArrowRight size={24} />
                                        </button>
                                    </>
                                }
                            </>
                            :
                            <>
                                <div className={classes.interactionContainer}>
                                    <div className={classes.verticalContainer}>
                                        <div className={classes.barcodeDisplay}>
                                            <ScanBarcode size={28} color='#0C0E29' />
                                            <p className={classes.barcodeDisplay__barcode}>{barcode}</p>
                                        </div>
                                        <div className={classes.errorMessage}>{t(errorMessage)}</div>
                                        <button className={classes.currentStep__primaryButton} onClick={() => reset()}>
                                            {t("Scan again")}
                                        </button>
                                    </div>
                                </div>
                            </>
                        }
                    </>}
                    {currentStep === 2 && <>
                        <h1 className={classes.currentStep__title}>{t("Recycle")}</h1>
                        <p className={classes.currentStep__subtitle}>{t("Put the contents of the carrier into the breaker")}</p>
                        <div className={classes.barcodeDisplay}>
                            <ScanBarcode size={28} color='#0C0E29' />
                            <p className={classes.barcodeDisplay__barcode}>{barcode}</p>
                        </div>
                        <div className={classes.interactionContainerCentered}>
                            <img className={classes.breaker__image} src={process.env.PUBLIC_URL + '/img/machines/breker.png'} alt={t("Breaker")} />
                        </div>
                        <button className={classes.currentStep__nextStepButton} style={{ paddingRight: '16px' }} onClick={() => reset()}>
                            {t("Recycle more waste material")}
                        </button>
                    </>}
                </div>
            </div>
        </div>
    )
}

const useStyles = makeStyles(() => ({
    registerContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "64px",

        width: "100%",
        height: "100%",
    },
    stepper: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        gap: "24px",
    },
    step: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "12px",

        // last step progressbar not visibiel
        "&:last-child $step__progressBarContainer": {
            display: "none",
        },
    },

    step__number: {
        width: "36px",
        height: "36px",
        borderRadius: "50%",
        backgroundColor: "#4654FB",
        color: "#F8F8F8",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "18px",
        fontFamily: "Lato, sans-serif",

        transition: "background-color 0.3s",
    },

    step__title: {
        fontSize: "18px",
        fontFamily: "Lato, sans-serif",

        margin: "0",

        transition: "color 0.3s",
    },

    step__progressBarContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",

        position: "relative",
    },

    step__progressBarBackground: {
        width: "124px",
        height: "2px",
        marginLeft: "12px",
        backgroundColor: "#DCDCDC",
    },

    step__progressBar: {
        height: "2px",
        marginLeft: "12px",
        backgroundColor: "#5CC958",
        transition: "width 0.3s",

        position: "absolute",
        top: "0",
        left: "0",
    },

    currentStepContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",

        gap: "8px",
    },

    currentStepCard: {
        width: "800px",
        height: "520px",

        borderRadius: "6px",
        backgroundColor: "white",

        // dropshadow
        boxShadow: "0px 3px 16px rgba(175, 175, 175, 0.25)",

        display: "flex",
        flexDirection: "column",
        alignItems: "center",

        position: "relative",

        padding: "16px",
        paddingTop: "32px",
    },

    currentStep__title: {
        fontSize: "24px",
        fontFamily: "Lato, sans-serif",
        fontWeight: "normal",
        color: "#0C0E29",

        margin: "0",
    },

    currentStep__subtitle: {
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        color: "#0C0E29",
        opacity: "0.8",

        margin: "0",
        marginTop: "16px",
    },

    loaderContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },

    currentStep__primaryButton: {
        height: "40px",

        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",

        padding: "8px 16px",

        borderRadius: "3px",
        backgroundColor: "#4654FB",
        color: "#F8F8F8",

        fontSize: "16px",
        fontFamily: "Lato, sans-serif",

        border: "none",

        cursor: "pointer",

        "&.disabled": {
            backgroundColor: "#DCDCDC",
            color: "#989898",
            cursor: "not-allowed",
            border: "none",
        }
    },

    currentStep__secondaryButton: {
        height: "40px",

        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",

        padding: "8px 16px",

        borderRadius: "3px",
        backgroundColor: "transparent",
        color: "#4654FB",

        fontSize: "16px",
        fontFamily: "Lato, sans-serif",

        boxSizing: "border-box",
        border: "1px solid #4654FB",

        transition: "background-color 0.3s",

        "&:hover": {
            backgroundColor: "#3B3AF1",
            color: "#F8F8F8",

            cursor: "pointer",

            transition: "background-color 0.3s",
        },

        "&.disabled": {
            backgroundColor: "#DCDCDC",
            color: "#989898",
            cursor: "not-allowed",
            border: "none",
        }
    },

    currentStep__nextStepButton: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",

        padding: "8px",
        paddingLeft: "16px",

        borderRadius: "3px",
        backgroundColor: "#4654FB",
        color: "#F8F8F8",

        fontSize: "16px",
        fontFamily: "Lato, sans-serif",

        border: "none",

        position: "absolute",
        bottom: "16px",
        right: "16px",

        cursor: "pointer",

        "&:hover": {
            backgroundColor: "#3B3AF1",

            cursor: "pointer",

            transition: "background-color 0.3s",
        },

        "&.disabled": {
            backgroundColor: "#DCDCDC",
            color: "#989898",
            cursor: "not-allowed",
            border: "none",
        }
    },

    currentStep__previousStepButton: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",

        padding: "8px",
        paddingRight: "16px",

        boxSizing: "border-box",

        borderRadius: "3px",
        border: "1px solid #4654FB",
        backgroundColor: "transparent",
        color: "#4654FB",

        fontSize: "16px",
        fontFamily: "Lato, sans-serif",

        position: "absolute",
        bottom: "16px",
        left: "16px",

        cursor: "pointer",
    },

    interactionContainer: {
        width: "calc(100% - 32px)",

        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
    },

    interactionContainerCentered: {
        width: "calc(100% - 32px)",

        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",

        gap: "24px",

        position: "absolute",
        top: "50%",
        transform: "translateY(-50%) translateY(40px)",
    },

    breaker__image: {
        height: "280px",
        width: "240px",

        objectFit: "cover",

        borderRadius: "3px",
    },

    verticalContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "24px",
    },

    confirmation: {
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",

        color: "#5CC958",
        backgroundColor: "#F3FBF2",

        border: "1px solid #5CC958",
        borderRadius: "6px",

        padding: "12px",
        marginTop: "24px",
        marginBottom: "16px",
    },

    input__container: {
        height: "40px",
        width: "400px",

        border: "none",

        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",

        position: "relative",
    },

    input__field: {
        height: "100%",
        width: "100%",

        padding: "8px",
        paddingRight: "40px",

        border: "1px solid #BDBDBD",
        borderRadius: "3px",

        fontSize: "16px",
        fontFamily: "Lato, sans-serif",

        boxSizing: "border-box",

        "&:focus": {
            outline: "none",
            border: "1px solid #4654FB",
        }
    },

    input__icon: {
        padding: "8px",

        position: "absolute",
        right: "0",
    },

    StockStepsContainer: {
        width: "fit-content",

        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "16px",
    },

    errorMessage: {
        maxWidth: "400px",
        padding: "12px",
        borderRadius: "6px",

        backgroundColor: "#FDF3F3",
        color: "#D84949",

        border: "1px solid #D84949",

        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
    },

    barcodeDisplay: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",

        marginTop: "24px",
    },

    barcodeDisplay__barcode: {
        fontSize: "20px",
        fontFamily: "Lato, sans-serif",
        fontWeight: "bold",
        color: "#0C0E29",

        margin: "0",
    },

    "@global": {
        "@keyframes rotation": {
            "0%": { transform: "rotate(0deg)" },
            "100%": { transform: "rotate(360deg)" },
        },
    },

    loader: {
        width: "48px",
        height: "48px",
        border: "5px solid " + FlagstoneTheme.palette.primary.main,
        borderBottomColor: "transparent",
        borderRadius: "50%",
        display: "inline-block",
        boxSizing: "border-box",
        animation: "rotation 1s linear infinite",
    },
}));